import { GridButtons } from "@/controls/buttons/GridButtons";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import type { Section } from "../../../models/Section";

type Props = {
	onSelectSection: (section: Section, modal: "update" | "delete") => void;
	showContextMenu: Function;
	showSectionFamily: boolean;
};
export const useTableData = ({
	onSelectSection,
	showContextMenu,
	showSectionFamily,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "SectionName",
			headerName: "Name",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "Asset",
			headerName: "Asset",
			minWidth: 120,
			flex: 1,
		},
		...(showSectionFamily
			? [
					{
						field: "SectionFamilyName",
						headerName: "Family",
						minWidth: 20,
						flex: 1,
					},
				]
			: []),
		{
			field: "Description",
			headerName: "Description",
			minWidth: 20,
			flex: 2,
		},
		{
			field: "StandDrawingCount",
			headerName: "Flow Sheets",
			minWidth: 20,
			flex: 1,
			valueFormatter: (params) => {
				const total = (params.data as Section | undefined)?.StandCount;
				if (params.value == null || total == null) return "-";
				return `${params.value}/${total}`;
			},
		},
		{
			colId: "HasProductionEvents",
			headerName: "Has Events",
			minWidth: 20,
			flex: 1,
			valueGetter: (params) =>
				(params.data as Section | undefined)?.HasProductionEvents
					? "Yes"
					: "No",
		},
		{
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				onEdit: () => onSelectSection(params.data as Section, "update"),
				onDelete: () => onSelectSection(params.data as Section, "delete"),
				setShowModal: () => {},
				showContextMenu: () =>
					showContextMenu(event, params.data, "sectionContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			sortable: false,
			flex: 1,
			minWidth: 150,
			maxWidth: 150,
			filter: false,
			autoHeaderHeight: true,
		},
	];
	return { columnDefs };
};
